import type { ThemeDefinition } from './types';

export const cleanMinimal: ThemeDefinition = {
  fontsUrl: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap',
  variables: {
    '--report-font-display': "'Inter', system-ui, sans-serif",
    '--report-font-body': "'Inter', system-ui, sans-serif",
    '--report-bg': '#ffffff',
    '--report-bg-surface': '#f9fafb',
    '--report-text': '#171717',
    '--report-text-secondary': '#525252',
    '--report-text-muted': '#a3a3a3',
    '--report-accent': '#171717',
    '--report-accent-dim': 'rgba(23, 23, 23, 0.06)',
    '--report-border': '#e5e5e5',
    '--report-border-strong': '#d4d4d4',
    '--report-stat-color': '#171717',
    '--report-stat-positive': '#16a34a',
    '--report-stat-negative': '#dc2626',
    '--report-callout-bg': '#f9fafb',
    '--report-callout-border': '#e5e5e5',
    '--report-surface-hover': '#f3f4f6',
    '--report-measure': '780px',
  },
};
